import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzIconComponent, SzIconName } from '../sz-icon';

@Component({
  selector: 'sz-empty-state',
  templateUrl: './sz-empty-state.component.html',
  styleUrls: ['./sz-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent]
})
export class SzEmptyStateComponent {
  readonly icon: InputSignal<SzIconName> = input.required<SzIconName>();
  readonly title: InputSignal<string> = input.required<string>();
  readonly description: InputSignal<string | null> = input<string | null>(null);
}
